export const COUNT_TABLE_RECORDS = 20;
export const PERIODS = [10, 15, 20, 25, 30, 35];
export const SK1 = [50, 80, 100, 133];
export const MEINBAU = 'MeinBau';
